<template>
  <div class="content has-text-grey has-text-centered">
    <p><b-icon :icon="icon" :custom-class="spin ? 'fa-spin' : ''" :size="size" /></p>
    <p v-if="typeof text === 'undefined'" v-t="'loading'" />
    <p v-else>{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingContent',
  props: {
    icon: { type: String, default: 'circle-notch' },
    spin: { type: Boolean, default: true },
    size: { type: String, default: 'is-large' },
    text: { type: String }
  }
}
</script>

<i18n>
{
  "en-US": {
    "loading": "Loading..."
  },
  "pt-BR": {
    "loading": "Carregando..."
  }
}
</i18n>
